import './index.css';

export default {
  name: 'Acarousel',
  props: {
    data: {
      type: Array,
      default: () => [
        { title: '栏目一', brief: '详细介绍', color: '#FF6600' },
        // { title: '栏目二', brief: '详细介绍', color: '#FFCC00' },
        // { title: '栏目三', brief: '详细介绍', color: '#66CCFF' },
      ]
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    size: { type: Number | String, default: () => 5 },
    height: { type: String, default: () => '42vh' },
    initialIndex: { type: Number | String, default: () => 0 },
    trigger: { type: String, default: () => '' },
    autoplay: { type: Boolean, default: () => true },
    interval: { type: Number | String, default: () => 2800 },
    indicatorPosition: { type: String, default: () => '' },
    arrow: { type: String, default: () => 'always' },
    type: { type: String, default: () => '' },
    loop: { type: Boolean, default: () => true },
    direction: { type: String, default: () => 'horizontal' },
  },
  render() {
    const { ...attrs } = this.$attrs;
    let multiple = this.size > 1 && this.data.length > 1;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class={['a-carousel', (multiple ? null : 'single')]}>
        <el-carousel
          height={this.height}
          initial-index={this.initialIndex}
          trigger={this.trigger}
          autoplay={this.autoplay && multiple}
          interval={this.interval}
          indicator-position={this.indicatorPosition}
          arrow={this.arrow}
          type={this.type}
          loop={this.loop}
          direction={this.direction}
          {...{ attrs }}
        >
          {data.length > 0 && data.map((a, b) => {
            if (b <= this.size) {
              let color = a.backgroundColor || a.color;
              let image = a.backgroundImage || a.image || a.img;
              let title = a.title || a.label || a.text || a.name;
              let brief = a.description || a.describe || a.explain || a.context || a.content || a.brief;
              return (
                <el-carousel-item key={b} style={{ backgroundColor: color, backgroundImage: `url(${image}` }}>
                  <div class="a-carousel-main">
                    {a.rander ? () => a.rander() : (
                      <div class="a-carousel-body">
                        <h3 class="a-carousel-title">{title}</h3>
                        <p class="a-carousel-description">{brief}</p>
                      </div>
                    )}
                  </div>
                </el-carousel-item>
              );
            }
          })}
        </el-carousel>
      </div>
    );
  }
}